<template>
  <nav class="nav-menu2-vpos">
    <div class="d-flex justify-content-between">
      <div class="d-flex justify-content-center w-50">
        <a
          class="w-25 title m-auto"
          style="font-family: system-ui; color: white"
          href="/vpos"
        >
          {{ currentLanguage.header_menuCuaHang }}</a
        >

        <input
          class="m-auto input-search"
          type="search"
          name=""
          placeholder="Tìm kiếm cửa hàng..."
        />
        <button class="btn-search">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>
      <div class="d-flex w-25">
        <!-- <div class="m-auto">
          <input  type="checkbox"     v-model="chungChecked"    @change="updateChecked()"   />
          <span class="p-2"> Chung</span>
        </div>
        <div class="m-auto"> nb
          <input  type="checkbox"  v-model="riengChecked"    @change="updateChecked()"  />
          <span class="p-2"> Riêng</span>
        </div> -->
        <div class="m-auto">
          <div class="dropdown flex-column d-flex">
            <span class="dropbtn">
              <img :src="imageUrls.iconTyGia" />
              {{ currentLanguage.header_TyGia }}
            </span>
            <span style="font-size: 11px"> {{ viewTyGia }} </span>
            <div class="dropdown-content" style="height: 95vh">
              <button
                class="w-100"
                @click="layTyGia()"
                style="border: none; height: 35px; background: cadetblue"
              >
                {{ currentLanguage.titleCapNhat }}
              </button>
              <span
                class="p-2 d-flex justify-content-sm-center"
                style="font-size: 16px; color: black"
                >{{ currentLanguage.capNhapTyGia }} : {{ timeUpdateTyGia }}
              </span>
              <a style="color: black" @click="selectItem(810)"
                ><div class="d-flex">
                  <div class="d-flex w-100" style="margin-left: 20px">
                    <div
                      class="w-50 d-flex flex-column"
                      style="border-right: 1px burlywood solid"
                    >
                      <span n style="font-weight: 100"> {{ currentLanguage.titleDongVietNam }}</span>
                    </div>
                    <div class="w-50 m-auto">
                      <span> </span>
                    </div>
                    <i
                      v-if="selectedIndex !== null && selectedIndex === 810"
                      class="fa fa-check-circle"
                      style="color: green"
                      aria-hidden="true"
                    ></i>
                  </div></div
              ></a>
              <a
                v-for="(item, index) in translatedCurrencies"
                :key="index"
                @click="selectItem(index)"
                style="color: black"
              >
                <div class="d-flex">
                  <!-- <img :src="getCurrencyImage(item.currency)" /> -->
                  <div class="d-flex w-100" style="margin-left: 20px">
                    <div
                      class="w-50 d-flex flex-column"
                      style="border-right: 1px burlywood solid"
                    >
                      <!-- <span style="font-weight: 600">{{ item.currency }}</span> -->
                      <span style="font-weight: 100">{{ item.name }}</span>
                    </div>
                    <div class="w-50 m-auto">
                      <span
                        >1 {{ item.currency }} =
                        {{ formattedPrice(item.muaCK) }} VND</span
                      >
                    </div>
                  </div>
                  <i
                    v-if="selectedIndex !== null && selectedIndex === index"
                    class="fa fa-check-circle"
                    style="color: green"
                    aria-hidden="true"
                  ></i>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="m-auto">
          <a class="" style="font-size: 18px; color: white">
            <i class="fa fa-bell-o" aria-hidden="true"></i
          ></a>
        </div>

        <div class="m-auto"  @click="showPopupLogin" v-if="Login">
          <!-- <span class="" style="color: white; cursor: pointer" data-toggle="modal" data-target="#exampleModalCenter">
            <i class="fa fa-user-circle-o" aria-hidden="true"></i>{{ currentLanguage.header_DangNhap }}</span> -->
            <span class="" style="color: white; cursor: pointer" id ="popupLogin">
            <i class="fa fa-user-circle-o pe-1" aria-hidden="true"></i>{{ currentLanguage.header_DangNhap }}</span>
        </div>
      </div>
      <!-- <div class="d-flex  dropdown" v-if="menuThongTin">
        <div class="d-flex align-items-center dropdown">
          <div class="text-color-white choose_menu dropbtn">
            <img
              class="rounded-circle"
              :src="imageUrls.urlAnh + avatar"
              style="width: 30px; height: 30px"
            />
            <span class="ms-md-1 fs-Acc_name max-text">{{ name }}</span>
          </div>
          <div class="dropdown-content">
           <main-menu-vpos></main-menu-vpos>
          </div>
        </div>
      </div> -->

      <div class="" v-if="menuThongTin">
        <div class="dropdown">
          <div class="text-color-white choose_menu dropbtn">
            <img
              class="rounded-circle"
              :src="imageUrls.urlAnh + avatar"
              style="width: 30px; height: 30px"
            />
            <span class="ms-md-1 fs-Acc_name max-text">{{ name }}</span>
          </div>
          <div class="dropdown-content">
            <main-menu-vpos></main-menu-vpos>
          </div>
        </div>
      </div>

      <div class="menu_right" style="display: flex">
        <a @click="selectItem(810)" class="lang" style="padding: 5px"
          ><img src="img/img-item-vimass-2022/co/vi-VN.gif" />
        </a>
        <a @click="selectItem(0)" class="lang" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/us.png" />
        </a>
        <a @click="selectItem(10)" class="lang" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/cn.jpg" />
        </a>
        <a @click="selectItem(3)" class="lang" style="padding: 5px"
          ><img
            style="width: 25px"
            src="https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_jpy.svg?h=32&w=32&ts=20230610195953&hash=C5D3E7B6B5EEE49C3D5C3C3A8B6798B8"
          />
        </a>
        <a @click="selectItem(13)" class="lang" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/kr.jpg" />
        </a>

        <!-- <a onclick="changeLang('hi')" class="lang"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/hi.png" />
        </a> -->
        <span
          class="clickShow"
          style="color: #ffffff; cursor: pointer; margin: auto; padding: 5px"
          ><i class="fa fa-ellipsis-h" aria-hidden="true"></i
        ></span>
        <div class="showCo" style="display: none; margin: auto">
          <a onclick="changeLang('us')" class="lang"
            ><img src="img/img-item-vimass-2022/co/indo.jpg" />
          </a>
          <a onclick="changeLang('us')" class="lang"
            ><img src="img/img-item-vimass-2022/co/tl.png" />
          </a>
          <a onclick="changeLang('us')" class="lang"
            ><img src="img/img-item-vimass-2022/co/thailan.png" />
          </a>
          <a onclick="changeLang('us')" class="lang"
            ><img src="img/img-item-vimass-2022/co/hu.jpg" />
          </a>
        </div>
        <a id="urlHome" @click="chuyenHome()" style="margin: 0 10px"
          ><img
            style="width: 35px; height: 35px"
            src="img/home-icon-white-8.jpg"
          />
        </a>
      </div>
    </div>
  </nav>
  <div v-show = "showFromLogin" class="m-auto modal-container-login" >
  <div style="position: absolute; background: rgb(13 13 14 / 52%);  width: 100%; height: calc(100vh - 60px);">
    <div class ="f-login-style">
      <div id="from-login" class ="f-login-from"><VposLogin ref="childRef"></VposLogin></div>
    </div>
  </div>
</div>


</template>
<script>
import { imageUrls } from "@/components/js/urlImg";
import { languages } from "@/components/js/langVpos";
import { postLayTiGia } from "@/components/js/VposServiceDanh";
import VposLogin from "../../Accounts/VposLogin.vue";
import MainMenuVpos from "../MainMenuVpos.vue";
import { KEY_CHONTYGIA } from '@/components/js/VposService';

export default {
  components: { VposLogin, MainMenuVpos },
  data() {
    return {
      showFromLogin: false,
      imageUrls: imageUrls,
      currentLanguage: languages.vi,
      Login: true,
      menuThongTin: false,
      register: false,
      user: "",
      listCuaHang: [],
      bannerQuangCao: true,
      myStore: false,
      name: "",
      email: "",
      avatar: "",
      lang: "",
      phone: "",
      timeUpdateTyGia: "",
      tyGiaNgoaiTe:[],
    
      viewTyGia: "",
      selectedIndex: null,
    };
  },
  created() {
    const savedLanguage = localStorage.getItem("languages");
    // const lang = this.$route.params.lang;
    this.lang = savedLanguage;
    if (languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }

    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  computed: {
    sortedCurrencies() {
      const order = ["USD", "EUR", "CNY", "KRW", "JPY"]; // Thứ tự mong muốn
      return this.tyGiaNgoaiTe.slice().sort((a, b) => {
        return order.indexOf(a.currency) - order.indexOf(b.currency);
      });
    },
    filteredCurrencies() {
      const order = ["USD", "EUR", "CNY", "KRW", "JPY"]; // Thứ tự mong muốn
      const sortedCurrencies = this.tyGiaNgoaiTe.slice().sort((a, b) => {
        return order.indexOf(a.currency) - order.indexOf(b.currency);
      });
      const filteredCurrencies = sortedCurrencies.filter((currency) =>
        order.includes(currency.currency)
      );
      const remainingCurrencies = this.tyGiaNgoaiTe.filter(
        (currency) => !order.includes(currency.currency)
      );
      return filteredCurrencies.concat(remainingCurrencies);
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },

    translatedCurrencies() {
      // console.log("aaâ " + this.tyGiaNgoaiTe)
      if (this.lang === 'vi') {
        return this.tyGiaNgoaiTe.map(currency => {
          switch(currency.name) {
            case "US DOLLAR":
              currency.name = "Đô la Mỹ";
              break;
            case "EURO":
              currency.name = "Euro";
              break;
            case "UK POUND STERLING":
              currency.name = "Bảng Anh";
              break;
            case "JAPANESE YEN":
              currency.name = "Yên Nhật";
              break;
            case "AUSTRALIAN DOLLAR":
              currency.name = "Đô la Úc";
              break;
              case "SINGAPORE DOLLAR":
              currency.name = "Đô la Singapore";
              break;
            case "THAI BAHT":
              currency.name = "Baht Thái";
              break;
            case "CANADIAN DOLLAR":
              currency.name = "Đô la Canada";
              break;
            case "SWISS FRANC":
              currency.name = "Franc Thụy Sĩ";
              break;
            case "HONG KONG DOLLAR":
              currency.name = "Đô la Hồng Kông";
              break;
            case "CHINESE YUAN":
              currency.name = "Nhân dân tệ Trung Quốc";
              break;
            case "DANISH KRONE":
              currency.name = "Krone Đan Mạch";
              break;
            case "INDIAN RUPEE":
              currency.name = "Rupi Ấn Độ";
              break;
            case "KOREAN WON":
              currency.name = "Won Hàn Quốc";
              break;
            case "KUWAITI DINAR":
              currency.name = "Dinar Kuwait";
              break;
            case "MALAYSIAN RINGGIT":
              currency.name = "Ringgit Malaysia";
              break;
            case "NORWEGIAN KRONE":
              currency.name = "Krone Na Uy";
              break;
            case "RUSSIAN RUBLE":
              currency.name = "Rúp Nga";
              break;
            case "SAUDI ARABIAN RIYAL":
              currency.name = "Riyal Ả Rập Saudi";
              break;
            case "SWEDISH KRONA":
              currency.name = "Krone Thụy Điển";
              break;          }
          return currency;
        });
      } else {
        return this.tyGiaNgoaiTe  ; // Trả về mảng tiền tệ không dịch nếu lang không phải là 'vi'
      }
    }
  },
  mounted() {
    this.layTyGia();

   // Add event listener for window clicks
    window.addEventListener('click', this.handleWindowClick);
    this.checkLogin();
    this.handleDataReceived();
    this.getUser();
    if (this.lang == "vi") {
      this.viewTyGia = "";
    } else {
      this.viewTyGia = KEY_CHONTYGIA;
    }
    this.selectedIndex = parseInt(localStorage.getItem("selectedIndex"), 10);
    console.log("Mounted - selectedIndex:", this.selectedIndex);


  },
  beforeUnmount(){
    // Remove event listener when component is about to be unmounted
   window.removeEventListener('click', this.handleWindowClick);
  },

  methods: {

   
    selectItem(index) {
      
      this.selectedIndex = index;
      localStorage.setItem("selectedIndex", index);
      if (index === 810 ) {
        localStorage.setItem("objTyGia", 1);
        this.changeLanguage("vi");
      } else {
        this.changeLanguage(this.getLanguage(this.tyGiaNgoaiTe[index]));
      }
    },
    getLanguage(item) {
      localStorage.setItem("objTyGia",  JSON.stringify(item));
      var chonTyGia =
        "1 " + item.currency + " = " + item.muaCK.toLocaleString() + " VND";
      localStorage.setItem("chonTyGia", chonTyGia);
      switch (item.currency) {
        case "USD":
        case "EUR":
          return "en";
        case "CNY":
          return "cn";
        case "JPY":
          return "en";
        case "KRW":
          return "kr";
        default:
          return "en";
      }
    },
    chuyenHome() {
      this.$router.push("/" + this.lang);
    },
    getCurrencyImage(currency) {
      return this.currencyImages[currency];
    },
    getNgonNgu(currency) {
      return this.ngonNgu[currency];
    },

    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },
    formattedPrice(tyGiaVND) {
      if (tyGiaVND !== undefined && tyGiaVND !== null) {
        return tyGiaVND.toLocaleString();
      } else {
        return ""; // Hoặc giá trị mặc định khác phù hợp với ứng dụng của bạn
      }
    },
    async layTyGia() {
      const res = await postLayTiGia();
      this.tyGiaNgoaiTe = res.result.currency;
    //  console.log(res.result.currency);
      this.timeUpdateTyGia = res.result.timeS;
    },
    checkLogin() {
      this.user = localStorage.getItem("user");
      if (this.user == "" || this.user == null) {
        this.Login = true;
        this.menuThongTin = false;
      } else {
        this.menuThongTin = true;
        this.Login = false;
      }
    },
    handleDataReceived() {
      var data = localStorage.getItem("dataCuaHang");
      this.listCuaHang = JSON.parse(data);
    },
    async getUser() {
      const dataFromLocalStorage = localStorage.getItem("user");
      if (dataFromLocalStorage) {
        try {
          const parsedData = JSON.parse(dataFromLocalStorage);
          this.name = parsedData.nameAlias;
          this.avatar = parsedData.avatar;
          this.phone = parsedData.phone;
          this.email = parsedData.email;
        } catch (error) {
          console.error("Error parsing data from localStorage:", error);
        }
      } else {
        console.warn("No data found in localStorage");
      }
    },
    showPopupLogin(){
     
      this.showFromLogin = true;
      console.log("show 1 ==> "+ this.showFromLogin);
      this.$refs.childRef.dangNhap();
      
    },
    handleWindowClick(event) {
    ///  console.log('Trạng thái trước khi thay đổi:' + event.target.className , this.showFromLogin);
      //iconTyGia
   if (this.showFromLogin && event.target.className ==="f-login-style"
    || this.showFromLogin && event.target.className ==="d-flex justify-content-between"
    || this.showFromLogin && event.target.className ==="d-flex justify-content-between w-50"
    || this.showFromLogin && event.target.className ==="m-auto"
    || this.showFromLogin && event.target.className ==="fa fa-search"
    || this.showFromLogin && event.target.className ==="m-auto input-search"
    || this.showFromLogin && event.target.className ==="nav-menu2-vpos"
    || this.showFromLogin && event.target.className ==="fa fa-bell-o"
    || this.showFromLogin && event.target.className ==="f-login-from") {
        // Close the popup if click occurred outside of it
            this.showFromLogin = false;
      }
      // console.log('Trạng thái sau khi thay đổi:', this.showFromLogin);
    
    },
  },
};
</script>

<!-- <style>
@import "@";
</style> -->

<style scoped>

.f-login-style{   
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    justify-content: center;
   
}

.f-login-from{
    max-height: auto!important;
    border-radius: 25px;
    display: flex;
}

.container {
  position: relative;
}

.center {
  position: absolute;
  top: 50%;
  width: 100%;
  text-align: center;
  font-size: 18px;
}

.dropbtn {
  background-color: #007abb;
  color: white;
  border: none;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: white !important;
  border-radius: 10px;
  box-shadow: 0px 8px 16px 0px rgba(200, 200, 200, 0.2);
  z-index: 2;
  left: -120px;
  height: 500px;
  overflow: auto;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  border-bottom: 1px #b4b7b9 solid;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: #007abb !important;
}
</style>



